// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"DigitalWizardPageWithTitleTemplate_themeRoot__ipAvC","wizardContainer":"DigitalWizardPageWithTitleTemplate_wizardContainer__1qaU4"};